import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSliderDot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 5.5,
		fill: "#CCDDEE",
		stroke: "white",
		strokeWidth: 5
	})
});
export default SvgSliderDot;
